import useConnectWallet from "@/store/wallet/useConnectWallet";
import { useCallback, useEffect, useState } from "react";

/**
 * useGetTokenList - 获取代币列表 Hook
 * 
 * 用于调用 Lottery 合约的 getTokenList 方法获取所有代币地址列表。
 * 
 * @returns {Object} 返回获取方法、结果和加载状态
 *   - getTokenList: 执行获取代币列表的函数
 *   - tokenList: 代币地址列表
 *   - tokenListLod: 加载状态
 */
const useGetTokenList = () => {
    // 存放数据
    const [tokenList, setTokenList] = useState<string[]>([]);
    // loading
    const [tokenListLod, setLoading] = useState(false);
    // 获取合约实例
    const { contractEvm: { Lottery } } = useConnectWallet();

    /**
     * 获取所有代币奖励列表
     * @returns 返回代币地址列表
     */
    const getTokenList = useCallback(async () => {
        setLoading(true);
        if (Lottery) {
            try {
                // 调用合约的 getTokenList 方法
                const result = await Lottery.getTokenList();
                // 保存结果
                setTokenList(result);
                setLoading(false);
                return result;
            } catch (e) {
                console.log("useGetTokenList", e);
                setLoading(false);
                return [];
            }
        }
        setLoading(false);
        return [];
    }, [Lottery]);
    useEffect(() => {
        getTokenList()
    }, [getTokenList])
    return { getTokenList, tokenList, tokenListLod };
};

export default useGetTokenList;
